import useLocalization from '@app/hooks/useLocalization'
import { IHotWaterSource } from '@app/interfaces/organization-passport/hot-water-source'
import { sortByName } from '@app/utils/sort-by-name/sort-by-name'
import { Form, Select } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface props {
  hotWaterSources: IHotWaterSource[]
}

const HotWaterSourcesItem: React.FC<props> = ({ hotWaterSources }) => {
  const [t, i18n] = useTranslation()
  const { localize } = useLocalization()
  return (
    <>
      <Form.Item
        label={t('hotWaterSource.hotWaterSource')}
        name={'hotWaterSource'}
      >
        <Select>
          {sortByName(localize(hotWaterSources)).map(
            (hotWaterSource, index) => {
              if (hotWaterSource.status) {
                return (
                  <Select.Option
                    key={index}
                    value={hotWaterSource.id!.toString()}
                  >
                    {hotWaterSource?.data?.name}
                  </Select.Option>
                )
              }
              return null
            },
          )}
        </Select>
      </Form.Item>
    </>
  )
}

export default HotWaterSourcesItem
